import React from "react";
import loader_spinner from "../img/loading.svg";

function Loader() {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        height: "100%",
      }}
    >
      <img style={{ width: "50px" }} src={loader_spinner} alt="Loading..." />
    </div>
  );
}

export default Loader;
